export class ReportsRoutesI18n {
    public static AccountOverviewByDate = 'Account Overview By Date';
    public static AvailableFundsSummary = 'Available Funds Summary';
    public static Aging = 'Aging';
    public static ByDate = 'By Date';
    public static Collections = 'Collections';
    public static CreditRequestHistory = 'Credit Request History';
    public static Fundings = 'Fundings';
    public static Ineligibles = 'Ineligibles';
    public static Purchases = 'Purchases';
    public static Reports = 'Reports';
    public static SearchResults = 'Search Results';
}
